export default __webpack_public_path__ + "static/media/skip-payment.08894fa3.svg";